import WorkerApiService from "../workerApiServices";


class TipoEstoqueService extends WorkerApiService {

    constructor(endpoint_url) {
        super(endpoint_url || '/api/tipoEstoque');
    }

    search(){
        return this.get(`/search`)
    }

    save(tipoDeEstoque){
        return this.post(`/save`, tipoDeEstoque)
    }


}


export default TipoEstoqueService